import PageTitle from "../../components/PageTitle";

export default function() {
    return (
        <div>
            <PageTitle title="Bem-vindo!" subtitle="Como podemos ajudar hoje?"/>
        </div>
    )
}